import { createRouter, createWebHistory } from 'vue-router'
import Guard from "@/services/middleware";

import BaseView from '../views/BaseView.vue'
import HomeView from '@/views/HomeView.vue'

import ClientsView from '@/views/Clients/ClientsView.vue'
import ClientsAdd from '@/views/Clients/ClientsAddView.vue'
import ClientsEdit from '@/views/Clients/ClientsEditView.vue'

import CollaboratorsView from '@/views/Collaborators/CollaboratorsView.vue'
import CollaboratorsAddView from '@/views/Collaborators/CollaboratorsAddView.vue'
import CollaboratorsEdit from '@/views/Collaborators/CollaboratorsEditView.vue'

import OrdersAdd from "@/views/Orders/OrdersAddView.vue";
import OrdersView from "@/views/Orders/OrdersView.vue";
import OrdersEdit from "@/views/Orders/OrdersEditView.vue";

import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import OrdersInfoView from '@/views/Orders/OrdersInfoView.vue';
import OrdersInfoCodeView from '@/views/OrdersInfoCodeView .vue';

const routes = [
  {
    path: "/auth",
    name: "auth",
    component: LoginView,
    beforeEnter: Guard.login,
  },
  {
    path: "/cadastro",
    name: "register",
    component: RegisterView,
  },
  {
    path: "/consultar",
    name: "ordersInfoCode",
    component: OrdersInfoCodeView,
  },
  {
    path: "",
    name: "base",
    component: BaseView,
    beforeEnter: Guard.auth,
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
        beforeEnter: Guard.auth,
      },
      {
        path: "/clientes",
        name: "clients",
        component: ClientsView,
        beforeEnter: Guard.auth,
      },
      {
        path: "/clientes/adicionar",
        name: "clientsAdd",
        component: ClientsAdd,
        beforeEnter: Guard.auth,
      },
      {
        path: "/clientes/editar/:id",
        name: "clientsEdit",
        component: ClientsEdit,
        beforeEnter: Guard.auth,
      },
      {
        path: "/colaboradores",
        name: "collaborators",
        component: CollaboratorsView,
        beforeEnter: Guard.auth,
      },
      {
        path: "/colaboradores/adicionar",
        name: "collaboratorsAdd",
        component: CollaboratorsAddView,
        beforeEnter: Guard.auth,
      },
      {
        path: "/colaboradores/editar/:id",
        name: "collaboratorsEdit",
        component: CollaboratorsEdit,
        beforeEnter: Guard.auth,
      },
      {
        path: "/coletas/:typePage",
        name: "orders",
        component: OrdersView,
        beforeEnter: Guard.auth,
      },
      {
        path: "/coletas/editar/:id",
        name: "ordersEdit",
        component: OrdersEdit,
        beforeEnter: Guard.auth,
      },
      {
        path: "/coletas/ver/:id",
        name: "ordersInfo",
        component: OrdersInfoView,
        beforeEnter: Guard.auth,
      },
      {
        path: "/coletas/adicionar",
        name: "ordersAdd",
        component: OrdersAdd,
        beforeEnter: Guard.auth,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
